import { NavigationLink } from "components/base/base";
import Page from "components/base/Page";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import SubSupplierProducts from "./products";

function SubSupplierPage() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="products" element={<SubSupplierProducts />} />
      </Route>

      <Route path="*" element={<Navigate to="products" />} />
    </Routes>
  );
}

const Layout = () => (
  <Page
    leftButtons={
      <div className="space-x-4">
        <NavigationLink to="/sub-supplier/products">Products</NavigationLink>
      </div>
    }
  >
    <Outlet />
  </Page>
);

export default SubSupplierPage;
